import { StatusIcon } from '../../..'
import styles from './Spinner.module.scss'

export const Spinner = () => {
  return (
    <>
      {/* @ts-expect-error: this component is bad and needs to be rewritten */}
      <StatusIcon className={styles.navbarSpinner} spin />
    </>
  )
}
